module.exports = {
  "name": "omit",
  "regExp": /^\*omit\*/,
  "processSafe":true,
  "parserFunc": function parser_omit() {}
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/csvtojson/libs/core/defaultParsers/parser_omit.js
// module id = 289
// module chunks = 0